import { Icon } from '@/components/shared/display/Icon';
import { BaseUIKitWrapper } from '@/components/uiKit/shared/BaseUIKitWrapper';
import { cn } from '@/lib/utils';
import { SignalStreamIcon } from '@/assets/Icons';
import { SensorModal } from '@/components/pages/AssetsPreviewPage/shared';
import { Asset } from '@/types/models/assets.types';
import React from 'react';
import { useParams } from 'react-router-dom';

const getRatioStyle = (a: number, b: number) => {
  const ratio = a / b;
  if (ratio <= 0.5) return 'text-critical bg-[#CC00001F]';
  else if (ratio <= 0.8 && ratio > 0.5) return 'text-alarm bg-[#FF891B1F]';
  else if (ratio > 0.8) return 'text-healthy bg-[#11975D1F]';
};

interface SensorsIndicatorProps {
  asset: Asset;
  isNA?: boolean;
}
export const SensorsNewIndicator = ({ asset, isNA }: SensorsIndicatorProps) => {
  const { siteId } = useParams();
  const { asset_ui_name, sensors_count_active, sensors_count_total, asset_supplier, asset_model, asset_id } =
    asset || {};
  const sensorStyle = isNA
    ? 'bg-gray-300 text-gray-500 opacity-80'
    : sensors_count_active !== undefined &&
      sensors_count_total !== undefined &&
      getRatioStyle(sensors_count_active, sensors_count_total);

  return (
    <BaseUIKitWrapper
      data-testid={`${asset_ui_name}_sensor_modal_trigger`}
      dialog={{
        title: `${asset_ui_name}${asset_supplier && asset_model ? ` - ${asset_supplier} ${asset_model}` : ''}`,
        element: siteId ? <SensorModal assetId={asset_id} siteId={siteId} /> : <></>,
        className: 'max-w-screen md:max-w-fit md:min-w-[1200px] max-h-[80vh] overflow-hidden flex flex-col',
      }}
    >
      <div
        className="flex flex-2 items-center gap-2 text-xs font-semibold pr-2 hover:bg-[#F0F2F7] hover:rounded-full"
        data-testid={'sensors_indicator'}
      >
        <div
          className={cn(
            'flex items-center justify-center h-[2rem] w-[2rem] bg-primary-400 rounded-full text-white',
            sensorStyle
          )}
        >
          <Icon icon={SignalStreamIcon} className="w-7 h-7" />
        </div>
        <div className="flex items-center whitespace-nowrap  text-xs ">
          {sensors_count_active + ' / ' + sensors_count_total}
        </div>
      </div>
    </BaseUIKitWrapper>
  );
};
